import React, { useCallback } from 'react'
import { Button as ReferaButton } from '@refera/ui-web'
import HeaderTitle from '_/components/header-title'
import useStyles from './styles'
import { navigate, useParams } from '@reach/router'
import { Grid } from '@material-ui/core'
import Button from '_components/button'
import { getHistoryLogs } from '_modules/history-logs/actions'
import { useDialog } from '_/hooks/use-dialog'

import { useDispatch } from 'react-redux'
import { ROUTES } from '_/utils/constants'
import { PayerDataFormProvider, usePayerDataForm } from './use-payer-data-form'
import { useFormContext } from 'react-hook-form'
import { PayerDataForm } from './PayerDataForm'

const Header = ({ serviceOrderId, budgetId }) => {
  const styles = useStyles()
  const { showDialog, closeDialog } = useDialog()
  const dispatch = useDispatch()

  const { isLoading, isSubmitDisabled } = usePayerDataForm()
  const methods = useFormContext()

  const {
    formState: { dirtyFields },
  } = methods

  const handleBackNavigation = useCallback(() => {
    dispatch(getHistoryLogs(serviceOrderId))
    return navigate(`${ROUTES.SERVICE_ORDER}/${serviceOrderId}/orcamento/${budgetId}`)
  }, [navigate, serviceOrderId, budgetId])

  const handleCancel = () => {
    if (Object.keys(dirtyFields).length > 0) {
      showDialog({
        type: 'warning',
        subject: 'Você tem certeza que deseja cancelar estas alterações?',
        labelApprove: 'Sim',
        labelCancel: 'Não',
        onApprove: () => {
          closeDialog()
          handleBackNavigation()
        },
        onCancel: closeDialog,
      })
    } else {
      handleBackNavigation()
    }
  }

  return (
    <HeaderTitle title="Dados do pagador" backButtonAction={handleBackNavigation}>
      <Grid className={styles.headerButtons}>
        <Button
          className={styles.button}
          type="submit"
          form="payerForm"
          color="primary"
          variant="contained"
          disabled={isLoading || isSubmitDisabled}
        >
          Salvar
        </Button>
        <ReferaButton variant="secondary" color="red" onClick={handleCancel}>
          Cancelar
        </ReferaButton>
      </Grid>
    </HeaderTitle>
  )
}

export default function PayerData() {
  const { serviceOrderId, budgetId } = useParams()
  const styles = useStyles()

  return (
    <PayerDataFormProvider>
      <Header serviceOrderId={serviceOrderId} budgetId={budgetId} />
      <div className={styles.container}>
        <PayerDataForm budgetId={budgetId} serviceOrderId={serviceOrderId} />
      </div>
    </PayerDataFormProvider>
  )
}
